import { OtherLinks, PersonalLinks, SidebarLinks } from "@/constant";
import { RouteGenerator } from "@/utils/routeGeneretor";
import { createBrowserRouter, Navigate } from "react-router-dom";
import RootLayout from "@/components/layout/rootLayout";
import App from "@/App";
// old
import SignIn from "@/pages/authentication/signIn/signIn";
import AuthLayout from "@/components/layout/authLayout";
// import SignUp from "@/pages/authentication/signUp/signUp";
import ForgotPassword from "@/pages/authentication/forgotPassword/forgotPassword";
import SetNewPassword from "@/pages/authentication/setNewPassword/setNewPassword";
import VerifyGoogleSignIn from "@/pages/authentication/verifyGoogleSignIn/verifyGoogleSignIn";

// new
import AuthLayoutV2 from "@/components/layout/authLayoutV2";

import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "@/pages/dashboard/dashboard";
import ApplicationSubmission from "@/pages/authentication/signUp/components/ApplicationSubmission";
import AssignmentSubmission from "@/pages/assignmentSubmission/AssignmentSubmission";
import Projects from "@/pages/projects/Projects";
import TestPage from "@/pages/testPage";
import ProjectManagement from "@/pages/orderMananagement/ProjectManagement";
import CreatorWithdrawsPage from "@/pages/withdrawRequests/withDrawRequests";
import NOT_FOUND_PAGE from "@/pages/error/404";
import Profile from "@/pages/profile/Profile";
import SignUpV2 from "@/pages/authenticationV2/signUp/SignUpV2";
import SignInV2 from "@/pages/authenticationV2/signIn/signInV2";

export const router = createBrowserRouter([
  // Authentication routes
  // {
  //   path: "/auth",
  //   element: <AuthLayout />,
  //   children: [
  //     {
  //       path: "sign-in",
  //       element: <SignIn />,
  //     },
  //     {
  //       path: "sign-up",
  //       element: <SignUp />,
  //     },
  //     {
  //       path: "forgot-password",
  //       element: <ForgotPassword />,
  //     },
  //     {
  //       path: "set-new-password",
  //       element: <SetNewPassword />,
  //     },
  //     {
  //       path: "verify",
  //       element: <VerifyGoogleSignIn />,
  //     },
  //   ],
  // },

  // authentication v2
  {
    path: "/auth",
    element: <AuthLayoutV2 />,
    children: [
      {
        path: "sign-in",
        element: <SignInV2 />,
      },
      {
        path: "sign-up",
        element: <SignUpV2 />,
      },
      {
        path: "verify",
        element: <VerifyGoogleSignIn />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "set-new-password",
        element: <SetNewPassword />,
      },
    ],
  },

  {
    path: "application-submitted",
    element: <ApplicationSubmission />,
  },
  {
    path: "assignment",
    element: <AssignmentSubmission />,
  },
  {
    path: "test-page",
    element: <TestPage />,
  },

  // Main app routes
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" replace />,
      },
      ...RouteGenerator(SidebarLinks),
      ...RouteGenerator(OtherLinks),
      ...RouteGenerator(PersonalLinks),
      {
        path: "dashboard",
        index: true,
        element: <Dashboard />,
      },
      {
        path: "withdraw-requests",
        index: true,
        element: <CreatorWithdrawsPage />,
      },

      {
        element: <Profile />,
        path: "profile",
      },
    ],
  },

  // Projects
  {
    path: "orders",
    element: (
      <ProtectedRoute>
        <RootLayout />
      </ProtectedRoute>
    ),

    children: [
      {
        path: "",
        element: <Projects />,
      },
      {
        path: "order-management/:id",
        element: <ProjectManagement />,
      },
    ],
  },
  {
    path: "*",
    element: <NOT_FOUND_PAGE />,
  },
]);
